export default {
  hero_badge: "Institute for Social Dynamics · 2026",
  hero_title_1: "Measuring Society.",
  hero_title_2: "Everblue Sea · Sociodynamics Institute",
  hero_subtitle: "늘푸른바다 사회동역학연구소",
  hero_desc_1: "Data is a record made by people.",
  hero_desc_2: "We rewrite the sentences of society from those records.",
  hero_compass: "A compass pointing to the suffering of the people",
  nav_analysis: "Analysis",
  nav_engines: "Engines",
  nav_papers: "Papers",
  nav_institute: "Institute",
  stat_countries: "Countries",
  stat_acled: "ACLED Events",
  stat_axioms: "Social Structure Design Axioms",
  stat_ssrn: "SSRN Papers",
  latest_title: "Latest Analysis",
  latest_all: "View All",
  engines_label: "Analytical Engines",
  engines_title: "Reading Society Through 12 Analytical Engines",
  engines_sub: "Four core engines and eight sub-engines measure social phenomena across layers.",
  papers_label: "Papers · Research",
  papers_title: "Research Papers",
  papers_sub: "SSRN · Giseub Kim · ORCID 0009-0004-7638-0182",
  about_label: "About the Lab",
  about_title: "Data is a record made by people.\nWe rewrite the sentences\nof society from those records.",
  about_compass: "A compass pointing to the suffering of the people",
  about_desc: "Everblue Sea Institute for Social Dynamics is an independent research organization. We publish sociodynamic reports combining public data with our own analytical framework, releasing all outputs with source code for open access.",
  hero_title_kr_label: "Everblue Sea Institute",
  // Country search
  country_search_hint: "↑↓ to move · Enter to open",
  country_search_clear: "Clear",
  country_report_count_one: "{{count}} report",
  country_report_count_other: "{{count}} reports",
  country_reports_none: "No reports",
  country_page_kicker: "Reports by Country",
  country_page_summary: "{{count}} reports on this country · newest first",
  country_page_switch: "Find another country",
  country_page_back: "Home",
  country_empty_title: "No reports on this country yet.",
  country_empty_desc: "New reports will be gathered here automatically. Try searching for another country.",
  country_not_found_title: "Unknown country code.",
  country_not_found_desc: "Please type a country name in the search box above.",
  country_scope_standalone: "Standalone",
  country_scope_regional: "Regional",
  country_open_report: "Open report",
  // Unified report search
  search_label: "Find reports by country or topic",
  search_placeholder: "Country, title or topic (e.g. Indonesia, protest, BSLI)",
  search_aria: "Search by country name, report title, topic or category",
  search_no_match: "No matching country or report.",
  search_group_countries: "Countries",
  search_group_categories: "Categories",
  search_group_reports: "Reports",
  search_view_all: "See all results",
  search_category_hint: "View in this category",
  search_page_kicker: "Report Search",
  search_page_title: "Results for “{{q}}”",
  search_page_prompt: "What are you looking for?",
  search_page_summary_one: "{{count}} report",
  search_page_summary_other: "{{count}} reports",
  search_page_countries: "Reports gathered by country",
  search_filter_all: "All",
  search_filter_label: "Filter by category",
  search_sort_label: "Sort",
  search_sort_newest: "Newest",
  search_sort_relevance: "Relevance",
  search_empty_title: "No matching reports.",
  search_empty_desc: "Try removing spaces or using another word. You can search by country name, report title or engine name (Λ¹², BSLI, Uprising Index …). Report bodies are not searched.",
  search_prompt_desc: "Search by country name, words in report titles, or engine and category names.",
};
